"use client"

import { Fragment, useEffect, useState } from "react"
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
  Card,
  CardContent,
  Divider,
  Paper,
  Chip,
  Alert,
  CircularProgress,
} from "@mui/material"
import { Colors } from "../../Assets/Styles/Colors"
import { Controller, useForm } from "react-hook-form"
import moment from "moment"
import ProjectServices from "../../Api/ProjectServices/Project.index"
import UserServices from "../../Api/UserServices/User.index"
import { ErrorToaster, SuccessToaster } from "../../Components/Toaster/Toaster"
import Storage from "../../Utils/Storage"
import { jwtDecode } from "jwt-decode"
import "react-datepicker/dist/react-datepicker.css"
import ReactDatePicker from "react-datepicker"
import DateRangeIcon from "@mui/icons-material/DateRange"
import ReportServices from "../../Api/Report/Report.index"
import { ErrorHandler } from "../../Utils/ErrorHandler"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"
import BusinessIcon from "@mui/icons-material/Business"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import CommentIcon from "@mui/icons-material/Comment"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import successSound from "../../Assets//bandicam 2025-08-26 15-58-13-510.mp3";

function Form() {
  const { setStorageItem, getStorageItem } = Storage()
  const currentDate = moment().format("YYYY-MM-DD")

  const [selectedDate, setSelectedDate] = useState(currentDate)
  const [selectWorkType, setSelectWorkType] = useState("onSite")
  const [limit, setLimit] = useState(10)
  const [showSetTimeDialog, setShowSetTimeDialog] = useState(false)
  const [showProfileDialog, setShowProfileDialog] = useState(false)
  const [loader, setLoader] = useState(false)
  const [getProject, setGetProject] = useState([{ project: "", hour_count: "",comments:"" }])
  console.log("🚀 ~ Form ~ getProject:", getProject)
  const [projectList, setProjectList] = useState([])
  const [user, setUser] = useState(getStorageItem("user"))

  const decodedToken = jwtDecode(user.token)
  const userIdFromToken = decodedToken.id
  const userId = userIdFromToken
console.log(userId)
  const navigate = useNavigate()
  const {
    register,
    setError,
    clearErrors,
    handleSubmit,
    setValue,
    reset,
    resetField,
    getValues,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projects: getProject,
    },
  })

  const getDayFromDate = (dateString) => {
    const date = new Date(dateString)
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    return days[date.getDay()]
  }

  const addProjectField = () => {
    setGetProject([...getProject, { project: "", hour_count: "" ,comments:"" }])
  }

  const removeProjectField = (index) => {
    const updatedProjects = [...getProject]
    updatedProjects.splice(index, 1)
    setGetProject(updatedProjects.length > 0 ? updatedProjects : [{ project: "", hour_count: "" ,comments:"" }])
  }

  const handleProjectChange = (value, index) => {
    const isAlreadySelected = getProject.some((project, i) => project.project === value && i !== index)
    if (isAlreadySelected) {
      console.log("Project already selected in another field!")
    } else {
      const updatedProjects = [...getProject]
      updatedProjects[index].project = value
      setGetProject(updatedProjects)
    }
  }

  const isProjectDisabled = (projectId, currentIndex) => {
    return getProject.some((project, index) => project.project === projectId && index !== currentIndex)
  }

  const handleHourCountChange = (value, index) => {
    const updatedProjects = [...getProject]
    updatedProjects[index].hour_count = value
    setGetProject(updatedProjects)
  }
  const handleCommentsChange = (value, index) => {
    const updatedProjects = [...getProject];
    updatedProjects[index].comments = value;
    setGetProject(updatedProjects);
  };
  

  const getAllProjects = async (page, limit, search, user, priority, status) => {
    const { data, responseCode } = await ProjectServices.getProject(
      page,
      limit,
      search,
      user,
      priority ? priority : "",
      status ? status : "",
    )
    try {
      setProjectList(data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (userId) {
      getAllProjects(1, 1000, "", userId, "", "")
    }
  }, [])

  const handleDateChange = (date) => {
    const formattedDate = moment(date).format("DD MMM YYYY ,dddd")
    setSelectedDate(date)
    setValue("date", formattedDate)
  }

  const CustomInput = ({ value, onClick }) => (
    <TextField
      fullWidth
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          "&:hover fieldset": {
            borderColor: Colors.primary,
          },
        },
      }}
      value={value}
      onClick={onClick}
      readOnly
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton onClick={onClick} sx={{ color: Colors.primary }}>
              <DateRangeIcon />
            </IconButton>
          </InputAdornment>
        ),
        ...register("date", { required: true }),
      }}
      error={!!errors.date}
      helperText={errors.date ? "Date is required" : ""}
    />
  )

  useEffect(() => {
    for (let index = 0; index < getProject.length; index++) {
      const watchProjects = watch(`projects[${index}].project`)
      if (watchProjects !== getProject[index].project) {
        setValue(`projects[${index}].project`, getProject[index].project)
      }
    }
  }, [getProject, setValue])

  const onSubmit = async (formData) => {
    setLoader(true)
    console.log("🚀 ~ onSubmit ~ formData:", formData)
    const projectsData = getProject?.map((projects) => ({
      _id: projects.project,
      hour: projects.hour_count,
      comments: projects.comments,  
    }))
    console.log(projectsData)

    const obj = {
      date: moment(selectedDate).format("YYYY-MM-DD"),
      day: getDayFromDate(selectedDate),
      workType: selectWorkType,
      projectIds: projectsData,
      comments: formData.comments,
    }

    console.log(obj)
    try {
      const { data, responseCode, message } = await ReportServices.UpdateStats(userId, obj)
      SuccessToaster("Your response has been submitted")

      reset({
        projects: [{ project: "", hour_count: "" }],
        comments: "",
      })
      if(userId == "6659c42816538d52c020215b"){
        console.log(true)
        const audio = new Audio(successSound);
        audio.play();
      }
  
      setGetProject([{ project: "", hour_count: "" }])
      navigate("/progress")
    } catch (error) {
      ErrorHandler(error)
      ErrorToaster(error?.message)
      console.log(error)
    }finally{
    setLoader(false)

    }
  }

  const getRealTime = async () => {
    try {
      const response = await axios.get("https://timeapi.io/api/time/current/zone?timeZone=Asia%2FKarachi")
      const apiTime = response?.data?.dateTime

      const responseTimeFormatted = moment(apiTime).format("HH:mm")
      const localTimeFormatted = moment().format("HH:mm")

      console.log("API Time:", responseTimeFormatted)
      console.log("Local Time:", localTimeFormatted)

      if (responseTimeFormatted !== localTimeFormatted) {
        console.log("⚠️ Time mismatch (hours/minutes)")
        setShowSetTimeDialog(true)
      } else {
        console.log("✅ Time is synced (hours/minutes)")
      }
    } catch (error) {
      console.log("Error:", error)
    }
  }

  const handleGetProfile = async () => {
    try {
      const { data } = await UserServices.getProfile(userId)
      console.log(data?.user?.name, "fata")
      if (
        data?.user?.name == "" ||
        data?.user?.phone == "" ||
        data?.user?.emergency_contact == "" ||
        data?.user?.nic == "" ||
        data?.user?.dob == "" ||
        data?.user?.designation == "" ||
        data?.user?.joining_date == "" ||
        data?.user?.marital_status == "" ||
        data?.user?.highest_education == "" ||
        data?.user?.home_address == ""
      ) {
        setShowProfileDialog(true)
      }
    } catch (error) {
      console.error("Error while fetching users:", error)
    }
  }

  useEffect(() => {
    getRealTime()
    handleGetProfile()
  }, [])

  return (
    <>
      <Dialog
        maxWidth="sm"
        open={showSetTimeDialog}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            overflow: "visible",
          },
        }}
      >
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "center",
              "& svg": { fontSize: 48, color: "#ff9800" },
            }}
          >
            <WarningAmberIcon />
          </Box>
          <Typography variant="h5" component="h2" fontWeight="600" gutterBottom>
            Time Synchronization Required
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
            Your system time doesn't match the official time. Please synchronize your computer's clock to continue.
          </Typography>
          <Alert severity="warning" sx={{ mt: 2, borderRadius: 2 }}>
            Accurate time is required for proper form submission
          </Alert>
        </Box>
      </Dialog>

      <Dialog
        maxWidth="sm"
        open={showProfileDialog}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            overflow: "visible",
          },
        }}
      >
        <Box sx={{ p: 4, textAlign: "center" }}>
          <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "center",
              "& svg": { fontSize: 48, color: Colors.primary },
            }}
          >
            <AccountCircleIcon />
          </Box>
          <Typography variant="h5" component="h2" fontWeight="600" gutterBottom>
            Complete Your Profile
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
            Some required profile information is missing. Please complete your profile to ensure smooth platform
            experience.
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: Colors.primary,
              color: Colors.black,
              fontWeight: 600,
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: Colors.primary,
                boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
                transform: "translateY(-2px)",
              },
              transition: "all 0.3s ease",
            }}
            onClick={() => navigate("/account")}
          >
            Complete Profile
          </Button>
        </Box>
      </Dialog>

      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          py: 4,
        }}
      >
        <Box sx={{ maxWidth: 1200, mx: "auto", px: 2 }}>
          <Paper
            elevation={0}
            sx={{
              background: `linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.primary}dd 100%)`,
              borderRadius: 4,
              mb: 4,
              overflow: "hidden",
              position: "relative",
              display:{md:"block", xs:"none"}
            }}
          >
            <Box
              sx={{
                p: 6,
                textAlign: "center",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background:
                    'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fillRule="evenodd"%3E%3Cg fill="%23ffffff" fillOpacity="0.05"%3E%3Ccircle cx="30" cy="30" r="4"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                  opacity: 0.3,
                },
              }}
            >
              <BusinessIcon sx={{ fontSize: 48, color: Colors.black, mb: 2 }} />
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  color: Colors.black,
                  fontWeight: 700,
                  mb: 1,
                  position: "relative",
                  fontSize:{md:"2.5rem", xs: "1.8rem"}
                }}
              >
                Developer Management
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: Colors.black,
                  opacity: 0.8,
                  fontWeight: 400,
                  position: "relative",
                }}
              >
                Track your daily work progress and project hours
              </Typography>
            </Box>
          </Paper>
          <Typography
                variant="h3"
                component="h1"
                sx={{
                  color: Colors.black,
                  fontWeight: 700,
                  my: 2,
                  position: "relative",
                  fontSize:{md:"2.5rem", xs: "1.8rem"},
                  display:{md:"none", xs:"block"}
                }}
              >
                Developer Management Form
              </Typography>
          <Card
            elevation={0}
            sx={{
              borderRadius: 4,
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              overflow: "visible",
              background: "#ffffff",
              mb:3
            }}
          >
            <CardContent sx={{ p: {md:4,sm:3,xs:1.5} }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontWeight: 600,
                        color: "text.primary",
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <DateRangeIcon sx={{ color: Colors.primary }} />
                      Basic Information
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}>Select Date</InputLabel>
                    <ReactDatePicker
                      selected={selectedDate}
                      onChange={handleDateChange}
                      customInput={
                        <CustomInput value={selectedDate ? moment(selectedDate).format("DD MMM YYYY, dddd") : ""} />
                      }
                      dateFormat="dd MMM yyyy, eeee"
                      minDate={moment().subtract(2, "days").toDate()}
                      maxDate={new Date()}
                    />
                    {errors.date && (
                      <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                        Date is required
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <InputLabel sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}>Work Type</InputLabel>
                    <TextField
                      fullWidth
                      select
                      {...register("workType", { required: true })}
                      value={selectWorkType}
                      onChange={(e) => setSelectWorkType(e.target.value)}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: Colors.primary,
                          },
                        },
                      }}
                    >
                      <MenuItem value="onSite">
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <BusinessIcon fontSize="small" />
                          On-Site
                        </Box>
                      </MenuItem>
                      <MenuItem value="wfh">
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <AccessTimeIcon fontSize="small" />
                          Work From Home
                        </Box>
                      </MenuItem>
                    </TextField>
                    {errors.workType && (
                      <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                        Work Type is required
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: "text.primary",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <BusinessIcon sx={{ color: Colors.primary }} />
                        Project Details
                      </Typography>
                      <Chip
                        label={`${getProject.length} Project${getProject.length > 1 ? "s" : ""}`}
                        size="small"
                        sx={{
                          backgroundColor: Colors.primary,
                          color: Colors.black,
                          fontWeight: 600,
                        }}
                      />
                    </Box>
                  </Grid>

                  {getProject?.map((project, index) => (
                    <Fragment key={index}>
                      <Grid item xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            p: 3,
                            borderRadius: 3,
                            borderColor: index === 0 ? Colors.primary : "divider",
                            borderWidth: index === 0 ? 2 : 1,
                            position: "relative",
                            background: index === 0 ? `${Colors.primary}08` : "transparent",
                          }}
                        >
                          {index !== 0 && (
                            <IconButton
                              onClick={() => removeProjectField(index)}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                backgroundColor: "#ff5252",
                                color: "white",
                                width: 32,
                                height: 32,
                                "&:hover": {
                                  backgroundColor: "#d32f2f",
                                  transform: "scale(1.1)",
                                },
                              }}
                              size="small"
                            >
                              <RemoveIcon fontSize="small" />
                            </IconButton>
                          )}

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <InputLabel sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}>
                                Select Project
                              </InputLabel>
                              <Controller
                                name={`projects[${index}].project`}
                                control={control}
                                rules={{ required: "Project is required" }}
                                render={({ field }) => (
                                  <Autocomplete
                                    {...field}
                                    options={projectList?.output?.projects || []}
                                    getOptionLabel={(option) => option.name}
                                    value={
                                      projectList?.output?.projects.find((item) => item._id === field.value) || null
                                    }
                                    onChange={(e, newValue) => {
                                      handleProjectChange(newValue?._id, index)
                                      field.onChange(newValue?._id)
                                    }}
                                    isOptionEqualToValue={(option, value) => option._id === value}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        placeholder="Search and select project"
                                        error={!!errors.projects?.[index]?.project}
                                        helperText={errors.projects?.[index]?.project?.message || ""}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            borderRadius: 2,
                                            "&:hover fieldset": {
                                              borderColor: Colors.primary,
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                    getOptionDisabled={(option) => isProjectDisabled(option._id, index)}
                                    ListboxProps={{
                                      style: {
                                        maxHeight: 200,
                                        overflowY: "auto",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <InputLabel sx={{ mb: 1, fontWeight: 600, color: "text.primary" }}>
                                Working Hours
                              </InputLabel>
                              <TextField
                                type="text"
                                fullWidth
                                value={project.hour_count}
                                placeholder="e.g., 8.5"
                                {...register(`projects[${index}].hour_count`, {
                                  required: "Working hours are required",
                                  pattern: {
                                    value: /^\d*(\.\d{0,2})?$/,
                                    message: "Invalid format. Use only numbers with up to two decimal places",
                                  },
                                })}
                                onChange={(e) => {
                                  handleHourCountChange(e.target.value, index)
                                  const input = e.target.value
                                  if (!input.match(/^\d*(\.\d{0,2})?$/)) {
                                    setError(`projects[${index}].hour_count`, {
                                      type: "pattern",
                                      message: "Invalid format. Use only numbers with up to two decimal places",
                                    })
                                  } else {
                                    clearErrors(`projects[${index}].hour_count`)
                                  }
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <AccessTimeIcon sx={{ color: Colors.primary }} />
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: 2,
                                    "&:hover fieldset": {
                                      borderColor: Colors.primary,
                                    },
                                  },
                                }}
                              />
                              {errors.projects && errors.projects[index]?.hour_count && (
                                <Typography variant="caption" color="error" sx={{ mt: 1, display: "block" }}>
                                  {errors.projects[index].hour_count.message}
                                </Typography>
                              )}
                            </Grid>

                            <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontWeight: 600,
                        color: "text.primary",
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <CommentIcon sx={{ color: Colors.primary }} />
                      Additional Comments
                    </Typography>
                    <TextField
                      type="text"
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Share any additional details about your work today..."
                      {...register(`projects[${index}].comments`, { required: "Comments are required" })}
                      error={!!errors.projects?.[index]?.comments}
                      helperText={errors.projects?.[index]?.comments?.message || ""}
                      onChange={(e) => {
                        handleCommentsChange(e.target.value, index);   // <-- update state
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: Colors.primary,
                          },
                        },
                      }}
                    />
                  </Grid>
                  
                          </Grid>
                        </Card>
                      </Grid>
                    </Fragment>
                  ))}

                  <Grid item xs={12}>
                    <Button
                      onClick={addProjectField}
                      variant="outlined"
                      startIcon={<AddIcon />}
                      disabled={getProject?.length >= projectList?.output?.projects?.length}
                      sx={{
                        borderColor: Colors.primary,
                        color: Colors.primary,
                        borderRadius: 2,
                        py: 1.5,
                        px: 3,
                        fontWeight: 600,
                        textTransform: "none",
                        "&:hover": {
                          borderColor: Colors.primary,
                          backgroundColor: `${Colors.primary}08`,
                        },
                        "&:disabled": {
                          opacity: 0.5,
                        },
                      }}
                    >
                      Add Another Project
                    </Button>
                  </Grid>

                  {/* <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontWeight: 600,
                        color: "text.primary",
                        mb: 3,
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <CommentIcon sx={{ color: Colors.primary }} />
                      Additional Comments
                    </Typography>
                    <TextField
                      type="text"
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Share any additional details about your work today..."
                      {...register("comments", { required: "Comments are required" })}
                      error={!!errors.comments}
                      helperText={errors.comments?.message}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          "&:hover fieldset": {
                            borderColor: Colors.primary,
                          },
                        },
                      }}
                    />
                  </Grid> */}

                  {!showSetTimeDialog && !showProfileDialog && (
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                        <Button
                          type="submit"
                          variant="contained"
                          size="large"
                          sx={{
                            backgroundColor: Colors.primary,
                            color: Colors.black,
                            fontWeight: 700,
                            fontSize: "1.1rem",
                            px: 6,
                            py: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                            "&:hover": {
                              backgroundColor: Colors.primary,
                              boxShadow: "0 12px 32px rgba(0,0,0,0.2)",
                              transform: "translateY(-2px)",
                            },
                            transition: "all 0.3s ease",
                          }}
                        >
                          {loader ? <CircularProgress /> : "Submit"}
                           
                        </Button>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </>
  )
}

export default Form
